<template>
    <div class="files d-flex flex-column h-100">
        <div class="file-wrapper-parent flex-grow-1">
            <div class="file-container">
                <div class="file-wrapper" v-for="file in files" :key="file.id">
                    <div class="file">
                        <div class="file-options">
                            <modal title="Edit File Name" button_content="Edit file name" :ref="'fileModal'+file.id" :hide_button="true">
                                <edit-file-name :file-id="file.id" :name="file.name"></edit-file-name>
                            </modal>
                            <modal title="Upload New Version" :ref="'uploadNewModal'+file.id" :hide_button="true">
                                <upload-files :file-id="file.id" :folder-id="file.folder_id" :key="`new-file-version--${file.id}`"></upload-files>
                            </modal>
                            <modal :title="'File History: ' + file.name" :ref="'fileHistory'+file.id" :hide_button="true">
                                <file-history :file="file"></file-history>
                            </modal>
                            <div class="btn-group">
                                <span class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    ...
                                </span>
                                <div class="dropdown-menu">
                                    <button class="dropdown-item" type="button" @click="openModal($event, 'fileModal'+file.id)" v-if="canModifyFile(file)" v-can="buildPermission('edit files')">Edit file name</button>
                                    <button class="dropdown-item" type="button" @click="openModal($event, 'uploadNewModal'+file.id)" v-if="canModifyFile(file)" v-can="buildPermission('edit files')">Upload new version</button>
                                    <button class="dropdown-item" type="button" @click="openModal($event, 'fileHistory'+file.id)" v-can="buildPermission('view')">View changelog</button>
<!--                                    <button class="dropdown-item" type="button" @click="$store.dispatch('selectFileForCopy', file)" v-if="!isDisabled" v-can="buildPermission('copy files')">Copy to folder</button>-->
                                    <a class="dropdown-item" :href="file.file_path" target="_blank">View</a>
                                    <a class="dropdown-item" :href="'/api/documents/file/' + file.id + '/download'" target="_blank" v-can="buildPermission('download files')">Download</a>
                                    <button class="dropdown-item" type="button" @click="$store.dispatch('deleteFile', file.id)" v-if="canModifyFile(file)" v-can="buildPermission('delete files')">Delete</button>
                                </div>
                            </div>
                        </div>
                        <div class="file-icon">
                            <img src="/images/file-icon.svg">
                            <span class="file-icon-type">{{file.name.split('.').pop()}}</span>
                        </div>
                        <div class="file-content">
                            {{file.name}}
                        </div>
                        <div class="file-select ">
                            <div class="col-8">
                                <span class="file-select-label">Add to Basket</span>
                                <label class="custom-checkbox">
                                    <input class="checkbox" name="select" type="checkbox" @click="$store.dispatch('selectFile', file)" :checked="selectedFiles[file.id] != undefined">
                                    <span class="checkbox-label"></span>
                                </label>
                            </div>

                            <div @click="$store.dispatch('selectFileForCopy', file)" v-if="!isDisabled" v-can="buildPermission('copy files')" class="col-5">
                                <span class="file-select-label">Copy</span>
                                <label class="custom-checkbox">
                                    <input class="checkbox" name="copy" type="checkbox" @click="$store.dispatch('selectFileForCopy', file)" :checked="clipboard[file.id] != undefined">
                                    <span class="checkbox-label"></span>
                                </label>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="file-footer d-flex">
            <div>
                <modal title="Upload File" button_content="+ Upload File" button_class="btn btn-sm btn-secondary" v-if="canUploadFile()" v-can="buildPermission('create files')">
                    <upload-files ref="fileUpload" :folder-id="currentFolderID" :key="`new-file--${currentFolderID}`"></upload-files>
                </modal>
            </div>
            <div class="ml-1" v-if="files && files.length > 1">
                <button class="btn btn-sm btn-secondary" @click="selectAllFiles">Add All To Basket</button>
                <button class="btn btn-sm btn-secondary" @click="copyAllFiles">Copy All</button>
            </div>
            <div class="file-footer-right flex-grow-1 d-flex justify-content-end">
                <button class="btn btn-secondary btn-sm mr-1" @click="$store.dispatch('copyFile', currentFolderID)" v-if="Object.keys(clipboard).length > 0 && canPasteFile()" v-can="buildPermission('copy files')">Paste File</button>
            </div>
        </div>
    </div>
</template>

<script>
    import uploadFiles from './Forms/UploadFile';
    import editFileName from './Forms/EditFileName';
    import fileHistory from './Generic/FileHistory';
    import {mapState, mapGetters} from 'vuex';

    export default {
        components: {
            uploadFiles,
            editFileName,
            fileHistory
        },
        props: {
            files: [Object, Array]
        },
        methods: {
            openModal(e, name){
                this.$refs[name][0].showModal(e);
            },
            canUploadFile(){
                if(this.isDisabled){
                    return false;
                }

                let folder = this.folders[this.currentFolderID];

                if(folder != undefined){
                    let folder_category = folder.folder_category == 'central' ? null : folder.folder_category;
                    return folder_category == this.jobType || this.jobType == null && folder.job_type == null;
                }

                return false;
            },
            canModifyFile(file){
                if(this.isDisabled){
                    return false;
                }

                return file.job_type_name == this.jobType || this.jobType == null && file.job_type == null;
            },
            canPasteFile(){
                let folder = this.folders[this.currentFolderID];

                if(folder != undefined){
                    let folder_category = folder.folder_category == 'central' ? null : folder.folder_category;
                    return folder_category == this.jobType || this.jobType == null && folder.job_type == null;
                }

                return false;
            },

            selectAllFiles(){
                const checkBoxes = document.querySelectorAll('input[type="checkbox"][name="select"]');
                checkBoxes.forEach(checkBox => checkBox.click());
            },

            copyAllFiles(){
                const checkBoxes = document.querySelectorAll('input[type="checkbox"][name="copy"]')
                checkBoxes.forEach(checkBox => checkBox.parentElement.parentElement.click());
            }
        },
        computed: {
            ...mapGetters({
                buildPermission: 'buildPermission'
            }),

            ...mapState({
                folders: 'folders',
                currentFolderID: 'currentFolderID',
                selectedFiles: 'selectedFiles',
                clipboard: 'clipboard',
                jobType: 'job_type',
                isDisabled: 'isDisabled'
            })
        }
    }
</script>
